import { render, staticRenderFns } from "./CompanyPeopleAndRoleListing.vue?vue&type=template&id=dbb3e18c&"
import script from "./CompanyPeopleAndRoleListing.vue?vue&type=script&lang=js&"
export * from "./CompanyPeopleAndRoleListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports